import { useQuery } from '@tanstack/react-query';

import { useStoreApi } from '../../api';
import { storeKeys } from '../../query-key-factory';
import { StoreItem, StoreItemResponse } from '../../types';

type GetFeeStoreItemContext = {
  meta?: {
    feeId?: string;
    causeId?: string;
  };
};

const useGetFeeStoreItem = () => {
  const StoreApi = useStoreApi();
  const getStoreFeeItem = async (context: GetFeeStoreItemContext) => {
    const { feeId, causeId } = context.meta || {};
    const { data } = await StoreApi.get<StoreItemResponse<StoreItem>>(
      `/store_items/student_fees/${feeId}?cause_id=${causeId}`
    );
    return data.store_item;
  };
  return getStoreFeeItem;
};

function useShowStoreFeeItem<T = StoreItem>({
  feeId,
  causeId,
  select,
  enabled = true,
}: {
  feeId?: string;
  causeId?: string;
  select?: (data: StoreItem) => T;
  enabled?: boolean;
}) {
  const getStoreFeeItem = useGetFeeStoreItem();
  const key = causeId && feeId ? storeKeys.id(causeId).items.studentFees.id(feeId).detail : [];

  return useQuery({
    queryKey: key,
    queryFn: getStoreFeeItem,
    enabled: !!feeId && !!causeId && enabled,
    meta: {
      causeId,
      feeId,
    },
    select,
  });
}

export { useGetFeeStoreItem, useShowStoreFeeItem };
